export abstract class MultipartFormData<T = unknown> {

  readonly file: File | Blob;
  readonly option: T | undefined;

  constructor(file: File | Blob, option: T | undefined) {
    this.file = file;
    this.option = option;
  }

  abstract build(): FormData;

}
